import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Route } from "react-router-dom";
import AccountSettingMenu from "./components/common/accountsetting-menu";
import BillingDetails from "Billingdetails";
import UsageHistory from "Usagehistory";
import ReportIssue from "ReportIssue";
import {
  fetchClientalldetails,
  fetchallEventunderClient,
  fetchtotalaccountusageofclient,
  fetchadminissueTokenOpen,
} from "AccountSettingsAction";
import PasswordSetting from "PasswordSetting";
import WhiteLevelForm from "WhiteLevelForm";

class Accountsettings extends Component {
  componentDidMount() {
    this.props.fetchClientalldetails(
      this.props.session,
      this.props.user.clientid,
      (CallBackResponse) => {
          this.props.fetchtotalaccountusageofclient(
            this.props.session,
            this.props.user.clientid,
            (response) => {
              this.setState({ loading: false });
            }
          );

          this.props.fetchadminissueTokenOpen(
            this.props.session,
            this.props.user.clientid,
            (CallBackResponse) => {
              
            }
          );
      }
    );
  }

  renderSettingOptionList() {
    let { accountsettingMenus, eventData, clientdataforbilling } = this.props;
    //console.log("accountsettingMenus1", accountsettingMenus);
    let planTypes = ["whitelabel", "multiplewhitelabel"];
    if (
      clientdataforbilling &&
      clientdataforbilling.length > 0 &&
      clientdataforbilling[0].plantype &&
      !planTypes.includes(clientdataforbilling[0].plantype)
    ) {
      accountsettingMenus = _.filter(accountsettingMenus, (obj) => {
        return obj.iconName != "appstore";
      });
    }
    
    return accountsettingMenus.map((item, index) => {
      return <AccountSettingMenu key={item.iconName} item={item} />;
    });
  }

  render() {
    let {user} = this.props;
    return (
      <>
      {user && user.isSuperAdmin ? (
        <div className="content-parent-container">
        <div className="content-submenu vertical-line">
          <div>
            <ul className="list-group">{this.renderSettingOptionList()}</ul>
          </div>
        </div>
        <div
          className="content-subcontainer"
          // style={{ width: `${contentContainerWidth}px` }}
        >
          <Route
            path="/dashboard/accountsettings/billings"
            component={BillingDetails}
          />
          <Route
            path="/dashboard/accountsettings/usagehistory"
            component={UsageHistory}
          />
          <Route
            path="/dashboard/accountsettings/reportissue"
            component={ReportIssue}
          />
          <Route
            path="/dashboard/accountsettings/appstore"
            component={WhiteLevelForm}
          />
          <Route
            path="/dashboard/accountsettings/passwordsetting"
            component={PasswordSetting}
          />
        </div>
      </div>
      ):('')}
   </>
    );
  }
}

function mapStateToProps(state) {
  var eventData = {};
  if (state.eventData[0]) {
    eventData = state.eventData[0];
  }
  return {
    accountsettingMenus: state.accountsettingMenus,
    session: state.session,
    user: state.user,
    eventData,
    clientdataforbilling: state.clientdataforbilling,
  };
}

export default connect(mapStateToProps, {
  fetchClientalldetails,
  fetchallEventunderClient,
  fetchtotalaccountusageofclient,
  fetchadminissueTokenOpen,
})(Accountsettings);
